import http from '../../baseUrl/HttpCommon';
import authHeader from '../authHeader/AuthHeader';

// 🔹 Get Pending Bima Payments
const getPendingBimaPayments = () => {
  return http.get('/Payment/PendingBimaPayments', {
    headers: authHeader(),
  });
};

// 🔹 Manual Bima Sync ({ paymentIds: [number] })
const manualBimaSync = (data) => {
  return http.post('/Payment/ManualBimaSync', data, {
    headers: authHeader(),
  });
};

const BemaPaymentsSyncService = {
  getPendingBimaPayments,
  manualBimaSync,
};

export default BemaPaymentsSyncService;
